<!-- TODO: 这个页面后续将用 JSX 重构 -->
<template>
  <div class="attr-list">
    <AttrCommonTab>
      <!-- 位置属性 -->
      <template v-if="attrsCategories.positionInfoOptions" v-slot:wzsx="slotProps">
        <div class="locationInfo pos-grid">
          <div class="divider" v-if="!slotProps.isHideTitle">{{ $tt("位置属性") }}</div>
          <div
            class="info"
            :class="{ 'attr-has-error': !!errorMsg(l.key) }"
            v-for="l in attrsCategories.positionInfoOptions"
            :key="l.key"
          >
            <div class="label">
              {{ $tt(l.label) }}:
            </div>
            <el-input-number
              :disabled="isFormDisabled || l.disabled"
              :controls="false"
              v-model.number="curComponent.style[l.key]"
              :precision="0"
              :min="0"
              @change="inputValChange(l.key)"
            />
            <span class="attr-error-tip">{{errorMsg(l.key) || ''}}</span>
          </div>
        </div>
      </template>
      <!-- 组件属性 -->
      <template v-if="attrsCategories.componentAttrs" v-slot:zjsx="slotProps">
        <div class="locationInfo">
          <div class="divider" v-if="!slotProps.isHideTitle">{{ $tt("组件属性") }}</div>
          <template v-for="l in attrsCategories.componentAttrs">
            <!-- <div
              v-if="!(l.key === 'alias' && !curComponent.style.kqds)"
              :key="l.key"
              :class="['info', twoLinesInfoKeys.includes(l.key) && 'twoLinesInfo']"
            > -->
            <div
              :key="l.key"
              :class="['info', twoLinesInfoKeys.includes(l.key) && 'twoLinesInfo', l.type === 'resultRadio' && 'resultRadioInfo', !!errorMsg(l.key) && 'attr-has-error']"
              v-if="backAttrVisible(l)"
            >
              <div class="label">
                <AttrHelpDot :help-key="l.key" :component="curComponent && curComponent.component" />
                {{ $tt(l.label) }}:
              </div>
              <UploadArea
                :src="curComponent.style[l.key]"
                v-if="uploadImageKeys.includes(l.key)"
                :handler="
                  () => {
                    showImagesResourceModal(l.key);
                  }
                "
                :deleteHandler="
                  () => {
                    resetImageDefaultSrc(l.key);
                  }
                "
              />
              <UploadArea
                v-if="l.key === 'musicControlIcon'"
                :src="musicControlIconPreviewSrc"
                :handler="() => showImagesResourceModal('musicControlIcon')"
                :deleteHandler="() => resetImageDefaultSrc('musicControlIcon')"
              />
              <!--数字输入框 -->
              <!-- <el-input
                v-if="numberInputeKeys.includes(l.key)"
                :disabled="isFormDisabled"
                v-model.number="curComponent.style[l.key]"
                :type="textInputKeys.includes(l.key) ? 'text' : 'number'"
              /> -->
              <el-input-number
                v-if="numberInputeKeys.includes(l.key)"
                :disabled="isFormDisabled"
                :controls="false"
                :min="limitVal(l.key, 'min')"
                :precision="limitVal(l.key, 'precision')"
                v-model.number="curComponent.style[l.key]"
                @change="inputValChange(l.key)"
              />
              <span v-if="l.key === 'btnLoadingTime' || l.key === 'interval'" style="margin-left: 5px;">{{ $tt("秒") }}</span>

              <!-- 文本输入框 -->
              <el-input
                v-if="textInputKeys.includes(l.key)"
                :disabled="isFormDisabled"
                v-model="curComponent.style[l.key]"
                :maxlength="limitVal(l.key, 'maxlength')"
                :placeholder="l.placeholder"
                :show-word-limit="true"
                type="text"
                @change="inputValChange(l.key)"
              />
              <span class="attr-error-tip" :style="arrAttrKeys.includes(l.key) ? {top: '25px',left: '0px'} : {}">{{errorMsg(l.key) || ''}}</span>

              <!-- textArea文本 -->
              <el-input
                v-if="l.key == 'inputContent'"
                :disabled="isFormDisabled"
                v-model="curComponent.propValue"
                type="textarea"
              />
              <el-input
                v-if="l.key === 'btnPressName'"
                :disabled="isFormDisabled"
                v-model="curComponent.style[l.key]"
                type="textarea"
              />
              <el-radio-group v-if="typeKeys.includes(l.key)" v-model="curComponent.style[l.key]">
                <el-radio v-for="item in l.options" :key="item.value" :label="item.value">{{ $tt(item.label) }}</el-radio>
              </el-radio-group>
              <!-- 颜色选择 -->
              <el-color-picker
                v-if="colorSelectKeys.includes(l.key)"
                v-model="curComponent.style[l.key]"
                :disabled="isFormDisabled"
                :show-alpha="l.showAlpha"
                size="mini"
              />
              <!-- 下拉选择框 -->
              <el-select
                v-if="carouselExtSelectKeys.includes(l.key)"
                :value="carouselExtSelectValue(l.key)"
                :placeholder="$tt('请选择')"
                @change="(val) => onCarouselExtSelect(l.key, val)"
              >
                <el-option
                  v-for="o in l.options"
                  :key="o.id"
                  :label="$tt(o.text || o.label)"
                  :value="o.id"
                >
                </el-option>
              </el-select>
              <el-select
                v-else-if="selectFormKeys.includes(l.key)"
                v-model="curComponent.style[l.key]"
                :placeholder="$tt('请选择')"
                @change="(val) => selectChange(l, val)"
              >
                <el-option
                  v-for="o in l.options"
                  :key="o.id"
                  :label="$tt(o.text || o.label)"
                  :value="o.id"
                >
                </el-option>
              </el-select>

              <!-- 开关 -->
              <el-switch
                v-if="switchFormKeys.includes(l.key)"
                v-model="curComponent.style[l.key]"
                active-color="#13ce66"
                inactive-color="#ff4949"
              >
              </el-switch>

              <!-- rtsp流的组件 -->
              <div class="rtspAdressGroups" v-if="l.key == 'rtspAdressGroups'">
                <el-button type="text" icon="el-icon-plus" class="attr-add-btn addGroup" @click="addRtspAdressGroup"
                  >{{ $tt("添加") }}</el-button
                >
                <div
                  class="rtspAdressGroup"
                  v-for="g in curComponent.style.rtspAdressGroups"
                  :key="g.id"
                >
                  <el-input v-model="g.name" :placeholder="$tt('名称')"></el-input>
                  <el-input
                    v-model="g.rtspAdress"
                    :placeholder="$tt('rtsp流地址')"
                  ></el-input>
                  <i
                    class="el-icon-delete deleteGroup"
                    @click="deleteGroup(g.id)"
                  ></i>
                </div>
              </div>

              <!-- 视频/音乐/文档 -->
              <div class="rtspAdressGroups" v-if="['videoNameGroups', 'musicNameGroups', 'documentNameGroups'].includes(l.key)">
                <div
                  class="rtspAdressGroup"
                  v-for="g in curComponent.style[l.key]"
                  :key="g.id"
                >
                  <el-input v-model="g.name" :placeholder="$tt('文件名称')" @change="inputValChange(l.key)"></el-input>
                </div>
              </div>

              <!-- 复选框 -->
              <el-switch
                v-if="checkboxKeys.includes(l.key)"
                v-model="curComponent.style[l.key]"
                active-color="#409eff"
                inactive-color="#dcdfe6"
              />
              <el-slider
                v-if="['opacity', 'backgroundOpacity'].includes(l.key)"
                v-model="curComponent.style[l.key]"
                :max="1"
                :step="0.1"
                style="width: 100%;"
              >
              </el-slider>
              <!-- 只有图片组件使用  资源库选图片 -->
              <UploadArea
                v-if="l.key == 'imageResource'"
                :handler="
                  () => {
                    showImagesResourceModal('imageResource');
                  }
                "
                :deleteHandler="
                  () => {
                    resetImageDefaultSrc('imageResource');
                  }
                "
                :src="`url(${curComponent.propValue.file_down_path})`"
              />

              <!-- 轮播图的添加资源 -->
              <div class="carouselRe" v-if="l.key == 'carouselPics'">
                <el-button
                  icon="el-icon-plus"
                  type="text"
                  class="attr-add-btn"
                  v-if="!curComponent.style.carouselPics.length"
                  @click="showCarouselModal"
                  >{{ $tt("添加资源") }}</el-button
                >
                <div class="resourceInfo" v-else>
                  <span>{{ $tt("已选") }}{{ curComponent.style.carouselPics.length }}{{ $tt("个资源") }}</span>
                  <span class="icons">
                    <i class="el-icon-edit-outline" @click="showCarouselModal"></i>
                    <i class="el-icon-delete" @click="deleteCarouselPics"></i>
                  </span>
                </div>
              </div>

              <div v-else-if="l.type === 'resultRadio'" class="result-radio-attr">
                  <el-radio-group v-model="curComponent.style[l.key]">
                      <el-radio label="color">{{ $tt("颜色") }}</el-radio>
                      <el-radio label="icon">{{ $tt("图标") }}</el-radio>
                  </el-radio-group>
                  <div class="result-radio-attr-div">
                      <el-color-picker
                          v-if="curComponent.style[l.key] === 'color'"
                          v-model="curComponent.style[l.colorKey]"
                          size="mini"
                      />
                      <UploadArea
                          v-if="curComponent.style[l.key] === 'icon'"
                          :handler="
                          () => {
                              showImagesResourceModal(l.iconKey);
                          }
                          "
                          :deleteHandler="
                          () => {
                              resetImageDefaultSrc(l.iconKey);
                          }
                          "
                          :src="`url(${curComponent.style[l.iconKey]})`"
                      />
                  </div>
              </div>

              <!-- 按钮图标选择 -->
              <template v-if="l.key === 'btnIcon'">
                <el-popover
                  placement="left"
                  width="264"
                  trigger="click"
                  popper-class="btn-icon-popover"
                >
                  <div class="btn-icon-container">
                    <div v-for="item in BTN_ICONS.glyphs" :key="item.unicode" :class="['btn-icon-item', item.unicode === curComponent.style[l.key] ? 'selected' : '']" @click="() => { btnIconClick(item.unicode) }">
                      <i :class="BTN_ICONS.font_family">{{ unicodeToChar(item.unicode) }}</i>
                    </div>
                  </div>
                  <div slot="reference">
                    <el-button size="mini">
                      <!-- <i v-if="curComponent.style[l.key]" :class="['wirdfont', curComponent.style[l.key]]" /> -->
                      <i v-if="curComponent.style[l.key]" :class="BTN_ICONS.font_family">{{ unicodeToChar(curComponent.style[l.key]) }}</i>
                      <span v-else>{{ $tt("请选择") }}</span>
                    </el-button>
                    <el-button v-if="curComponent.style[l.key]" type="text" @click="btnIconClear">{{ $tt("清空") }}</el-button>
                  </div>
                </el-popover>
              </template>

              <!-- 绑定子页面 -->
              <BindPage v-if="l.key === 'bindPage'"></BindPage>

            </div>
          </template>
        </div>

      </template>
    </AttrCommonTab>

    <!-- 图片资源的modal -->
    <ImagesResourceModal
      ref="imagesResourceModal"
      :modalOperationKey="modalOperationKey"
      :setCarouselPics="setCarouselPics"
      @confirm="imageModalConfirm"
    />

    <!-- 多图轮播已选择modal -->
    <CarouselSeletedPicModal
      ref="carouselSeletedPicModal"
      :showImagesResourceModal="showImagesResourceModal"
    />
  </div>
</template>

<script>
import {
  COMPONENT_ATTRS_CONFIG,
  NO_MATCH_COMPONENT_ATTRS,
  ATTRS_VALIDATE_MAP
} from "@/utils/attrNameData";
// import { BTN_ICONS } from '@/constants/btnIcon';
import BTN_ICONS from '@/assets/btnfont/wirdfont.json';
import UploadArea from "@/components/UploadArea";
import ImagesResourceModal from "@/components/ImagesResourceModal";
import CarouselSeletedPicModal from "@/components/CarouselSeletedPicModal";
import eventBus from '@/utils/eventBus'
import { getCurComponentsInd, unicodeToChar } from '@/utils/utils';
import { clampComponentsToCanvas } from "@/utils/clampComponentsToCanvas";
import {
  clearCarouselExtOnStyle,
  getExtFieldByAttrKey,
  initCarouselExtOnStyle,
  isLegacyCarousel,
  setExtFieldByAttrKey,
} from "@/utils/carouselExt";
import {
  clearMusicControlIcon,
  musicControlIconUploadPreview,
} from "@/utils/musicExt";

import { mapState } from "vuex";
import BindPage from './AttrComp/bindPage';
import AttrCommonTab from './AttrCommonTab';
import AttrHelpDot from './AttrHelpDot';

export default {
  components: {
    UploadArea,
    ImagesResourceModal,
    CarouselSeletedPicModal,
    BindPage,
    AttrCommonTab,
    AttrHelpDot
  },
  data() {
    return {
      BTN_ICONS,
      twoLinesInfoKeys: ["rtspAdressGroups", "videoNameGroups", "documentNameGroups", "musicNameGroups", "bindPage", "carouselPics"],
      excludes: ["Picture", "Group", "Back"], // 这些组件不显示内容
      attrsCategories: {},
      selectKey: ["textAlign", "borderStyle", "verticalAlign"],
      attrNameData: {},
      textInputKeys: [
        "alias",
        "pageName",
        "city",
        // "btnPressName",
        "buttonName",
        "url"
      ],
      arrAttrKeys: [
        'documentNameGroups',
        'videoNameGroups',
        'musicNameGroups'
      ],
      numberInputeKeys: [
        "fontSize",
        "borderRadius",
        "pagesizeWidth",
        "pagesizeHeight",
        "interval",
        'btnLoadingTime',
        'circleSize',
        'trackSize',
        "pageWidth",
        "pageHeight"
      ],
      switchFormKeys: ["grid", "textScroll", 'btnLoading'],
      typeKeys: ['backgroundType', 'pressBackgroundType', 'isShowMenu'],
      colorSelectKeys: ["color", "backgroundColor", "pressBackgroundColor", 'circleColor', 'trackColor', 'activeColor', 'fontColor'],
      uploadImageKeys: [
        "backgroundImage",
        "pressBackgroundImage",
        "backPicSrc",
      ],
      checkboxKeys: ["kqds", "oneClick", "modalConfirm", "pressRing", "allowChanges", "loopplay"],
      selectFormKeys: ["fontFamily", "textScrollDir", "textScrollSpeed", "backgroundSize", "direction", "imgStyle", "displayMode"],
      carouselExtSelectKeys: ["carouselPlayMode", "carouselVisualStyle", "carouselLayoutDirection"],
      modalOperationKey: "",
      // 页面是否切换
      pageChanged: false,
      attrActive: 'common'
    };
  },
  mounted() {
    this.initAttrNameData();
  },
  computed: {
    ...mapState([
      "canvasStyleData",
      "curComponent",
      "pageOptions",
      "componentData",
      "selectedCurrentPage",
      "curErrorMap",
      "isChildPage"
    ]),
    isFormDisabled() {
      return this.curComponent.isLock;
    },
    isBackC() {
      return this?.curComponent?.component == "Back";
    },
    limitVal() {
      return (key, propKey) => {
        const val = ATTRS_VALIDATE_MAP[key] && ATTRS_VALIDATE_MAP[key][propKey];
        if (val !== null && val !== undefined && val !== '') {
          return val;
        }
        return undefined;
      };
    },
    errorMsg() {
      return (key) => {
        const id = this.curComponent.id;
        return this.curErrorMap[id] && this.curErrorMap[id][key];
      };
    },
    musicControlIconPreviewSrc() {
      if (!this.curComponent || !this.curComponent.style) {
        return "";
      }
      return musicControlIconUploadPreview(this.curComponent.style);
    },
    itemIsShow() {
      return (l) => {
        let isShow = true;
        if (l.key === 'btnLoadingTime') {
          isShow = !!this.curComponent.style.btnLoading;
        } else if (l.key === "carouselLayoutDirection") {
          isShow =
            this.curComponent.component === "Carousel" &&
            !isLegacyCarousel(this.curComponent.style);
        } else if (l.parentKey) {
          isShow = this.curComponent.style[l.parentKey] === l.typeValue;
        }
        return isShow;
      };
    },
    backAttrVisible() {
      return (l) => {
        if (!l) {
          return false;
        }
        if (l.key === "pageWidth" || l.key === "pageHeight") {
          return this.isChildPage;
        }
        if (l.key === "isShowMenu") {
          return !this.isChildPage;
        }
        return this.itemIsShow(l);
      };
    }
  },
  watch: {
    selectedCurrentPage: {
      handler(newV, oldValue) {
        if (newV === oldValue) {
          // 页面未改变
          this.pageChanged = false;
        } else {
          this.pageChanged = true;
        }
      },
      deep: true
    },
    curComponent: {
      handler(newV, oldValue) {
        // 页面切换时，应该排除此背景名称改变调整
        if (
          (newV.style.pageName || oldValue.style.pageName) && !this.pageChanged &&
          newV.component == "Back" //必须是背景组件才修改页面名称
        ) {
          //修改pageName时
          const d = this.pageOptions.map((p) => {
            if (p.value == this.selectedCurrentPage) {
              p.label = newV.style.pageName;
            } else if (p.children && p.children.length > 0) {
              p.children.forEach((child, childInd) => {
                if (child.value == this.selectedCurrentPage) {
                  p.children[childInd].label = newV.style.pageName;
                }
              })
            }
            return p;
          });
          this.$store.commit("setPageOptions", d);
        }
        this.initAttrNameData(newV);
        if (this.pageChanged) {
          this.pageChanged = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    unicodeToChar,
    handleAttrChange(val) {
      this.attrActive = val;
    },
    btnIconClear() {
      this.curComponent.style.btnIcon = '';
    },
    btnIconClick(key) {
      this.curComponent.style.btnIcon = key;
    },
    imageModalConfirm(info) {
        this.curComponent.style[this.modalOperationKey] = info.file_down_path;
        this.curComponent.style[this.modalOperationKey + 'Info'] = info;
    },
    selectChange(l, val) {
      if (l.key === 'imgStyle') {
        let name = l.options.filter((item) => item.id === val)[0].text;
        this.curComponent.style.imgStyleName = name;
      }
    },
    carouselExtSelectValue(key) {
      if (!this.curComponent || !this.curComponent.style) {
        return key === "carouselLayoutDirection" ? "horizontal" : "legacy";
      }
      return getExtFieldByAttrKey(this.curComponent.style, key);
    },
    onCarouselExtSelect(key, val) {
      if (!this.curComponent || !this.curComponent.style) {
        return;
      }
      const style = this.curComponent.style;
      if (val !== "legacy" || key === "carouselLayoutDirection") {
        initCarouselExtOnStyle(style);
      }
      setExtFieldByAttrKey(style, key, val);
      const ext = style.carouselExt;
      if (ext) {
        const play = ext.playMode || "legacy";
        const visual = ext.carouselStyle || "legacy";
        if (play === "legacy" && visual === "legacy") {
          clearCarouselExtOnStyle(style);
        }
      }
      this.$store.commit("recordSnapshot");
    },
    inputValChange(key) {
      const validateFunc = ATTRS_VALIDATE_MAP[key] && ATTRS_VALIDATE_MAP[key].validate;
      if (validateFunc && typeof validateFunc === 'function') {
        eventBus.$emit("inputValidate", {
          key,
          val: this.curComponent.style[key],
          id: this.curComponent.id,
          otherVal: this.curComponent.style
        });
      }
      if (
        this.isChildPage &&
        (key === "pageWidth" || key === "pageHeight") &&
        this.curComponent &&
        this.curComponent.component === "Back"
      ) {
        const w = Number(this.curComponent.style.pageWidth);
        const h = Number(this.curComponent.style.pageHeight);
        if (clampComponentsToCanvas(this.componentData, w, h)) {
          this.$store.commit("recordSnapshot");
        }
        this.$nextTick(() => {
          eventBus.$emit("locateCanvas");
        });
      }
    },
    addRtspAdressGroup() {
      this.$store.commit("changeRtspAdressGroups", {
        name: "",
        rtspAdress: "",
        id: new Date().valueOf(),
      });
    },
    deleteGroup(id) {
      this.$store.commit("deleteRtspAdressGroup", id);
    },
    addVideoNameGroup() {
      this.$store.commit("changeVideoNameGroups", {
        name: "",
        id: new Date().valueOf(),
      });
    },
    deleteVideoGroup(id) {
      this.$store.commit("deleteVideoGroup", id);
    },
    addDocumentNameGroup() {
      this.$store.commit("changeDocumentNameGroups", {
        name: "",
        id: new Date().valueOf(),
      });
    },
    deleteDocumentGroup(id) {
      this.$store.commit("deleteDocumentGroup", id);
    },
    showCarouselModal() {
      this.$refs.carouselSeletedPicModal.switchDialogVisible(true);
      const { carouselPics } = this.curComponent.style;
      // console.log(carouselPics);
      this.$refs.carouselSeletedPicModal.initCheckedPictures();
    },
    deleteCarouselPics() {
      this.$refs.carouselSeletedPicModal.confirmToChange(22, true);
    },
    setCarouselPics(v) {
      this.$refs.carouselSeletedPicModal.setCarouselPics(v);
    },
    showImagesResourceModal(key) {
      this.modalOperationKey = key;
      this.$refs.imagesResourceModal.switchDialogVisible(true);
    },
    resetImageDefaultSrc(key) {
      const all = this.componentData;
      // const index = this.componentData.findIndex(
      //   (i) => i.id == this.curComponent.id
      // );
      const ret = getCurComponentsInd(this.componentData, this.curComponent);
      let obj = {};
      if (key === "musicControlIcon") {
        const style = { ...this.curComponent.style };
        clearMusicControlIcon(style);
        obj = {
          ...this.curComponent,
          style,
        };
      } else if (key == "imageResource") {
        // 图片组件的处理
        obj = {
          ...this.curComponent,
          propValue: {
            pictureSrc: require("@/assets/title.jpg"),
            pictureName: "默认图片",
            pictureMd5: "default",
          },
        };
      } else {
        // 其他组件的图片属性处理
        obj = {
          ...this.curComponent,
          style: {
            ...this.curComponent.style,
            [key]: null,
            backgroundInfo: null,
            ...(key == "backgroundImage" ? { backgroundColor: "#409eff" } : {}),
            ...(key == "pressBackgroundImage" ? { pressBackgroundImageInfo: null } : {})
          },
        };
      }
      // all.splice(index, 1, obj);
      if (ret.parentInd !== -1) {
        // 生态组件下的子组件
        all[ret.parentInd].propValue.splice(ret.index, 1, obj);
      } else {
        all.splice(ret.index, 1, obj);
      }
      this.$store.commit("setCurComponent", {
        component: obj,
      });
      this.$store.commit("setComponentData", all);
    },
    getPicSrc(s) {
      if (!s) return;
      return s.src.split("(")[1]?.split(")")[0];
    },
    initAttrNameData(newV) {
      const { component, style } = newV || this.curComponent;

      if (!style.textScroll && component == "v-text") {
        //处理 文字组件中的动态属性
        this.attrsCategories = {
          ...COMPONENT_ATTRS_CONFIG["v-text"],
          componentAttrs: COMPONENT_ATTRS_CONFIG[
            "v-text"
          ].componentAttrs.filter(
            (i) => i.key != "textScrollDir" && i.key != "textScrollSpeed"
          ),
        };
        return;
      }
      this.attrsCategories =
        COMPONENT_ATTRS_CONFIG[component] || NO_MATCH_COMPONENT_ATTRS;
    },
    pageNameChangeHandler(v) {
      this.$store.commit("setCurrPageName", v);
    },
    handleUploadChange(e, key) {
      const file = e.target.files[0];
      if (!file.type.includes("image")) {
        toast("只能插入图片");
        return;
      }

      const reader = new FileReader();
      reader.onload = (res) => {
        const img = new Image();
        const fileResult = res.target.result;
        img.onload = () => {
          if (!key) {
            this.$store.commit("setCanvasStyle", {
              ...this.canvasStyleData,
              backPicSrc: fileResult,
            });
          } else {
            this.$store.commit("setShapeSingleStyle", {
              key, //更新的style属性key
              value: `url(${fileResult})`,
            });
          }
        };
        img.src = fileResult;
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>

<style lang="scss">
.attr-list {
  .el-input-number .el-input__inner {
    text-align: left;
  }
}
.resultRadioInfo {
  align-items: start !important;
}
.result-radio-attr {
  .el-radio-group {
    margin: 10px 0px;
  }
  .result-radio-attr-div {
    margin-top: 10px;
  }
}
.btn-icon-popover {
  padding-right: 2px !important;
}
.attr-list {
  .el-collapse {
    border: none;
    .locationInfo {
      border-bottom: none !important;
      padding-bottom: 0px !important;
    }
  }
  .el-collapse-item {
    border-bottom: 1px solid #ebeef5;
  }
  .el-collapse-item__header {
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    font-weight: 600;
    color: #303133;
    background: transparent;
    border: none;
  }
  .el-collapse-item__wrap {
    overflow: visible;
    border: none;
    background: transparent;
  }
  .el-collapse-item__content {
    padding-bottom: 12px;
  }
}
</style>
<style lang="scss" scoped>
.attr-list {
  overflow-x: hidden;
  overflow-y: visible;
  padding: 0 8px 16px 8px;
  height: auto;
  .currPageBack {
    width: 200px;
    height: 200px;
  }
  .info {
    display: flex;
    align-items: center;
    margin: 12px 0;
    width: 100%;
    position: relative;
    min-width: 0;
    gap: 12px;
  }
  .twoLinesInfo {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 8px;
    margin: 12px 0;
  }
  .pos-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px 12px;
    .divider {
      grid-column: 1 / -1;
    }
    .info {
      margin: 0;
      min-width: 0;
      flex-direction: column;
      align-items: stretch;
      gap: 6px;
      .label {
        min-width: 0;
        width: 100%;
        margin-right: 0;
      }
    }
  }
  .rtspAdressGroups {
    width: 100%;
    min-width: 0;
    .addGroup {
      margin: 4px 0 10px;
    }
    .rtspAdressGroup {
      border: 1px solid #ebeef5;
      border-radius: 6px;
      position: relative;
      padding: 6px 28px 6px 6px;
      margin-bottom: 10px;
      margin-right: 0;
      box-sizing: border-box;
      .deleteGroup {
        position: absolute;
        right: 6px;
        font-size: 16px;
        cursor: pointer;
        color: #f56c6c;
        top: 50%;
        transform: translate(0px, -50%);
      }
    }
  }
  .label {
    font-size: 12px;
    color: #909399;
    margin: 0;
    min-width: 52px;
    max-width: none;
    flex-wrap: nowrap;
    text-align: left;
    padding-right: 0;
    flex-shrink: 1;
  }
  .el-checkbox__inner {
    width: 20px !important;
    height: 20px !important;
  }
  .locationInfo {
    border-bottom: 1px solid #ebeef5;
    padding-bottom: 4px;
    .divider {
      font-size: 13px;
      line-height: 1;
      color: #303133;
      height: auto;
      text-align: left;
      border-left: 3px solid #409eff;
      margin: 16px 0 12px;
      padding: 0 8px;
      font-weight: 600;
    }
    .carouselRe {
      flex: 1;
      .el-button--small {
        width: 166px;
      }
      .resourceInfo {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        align-items: center;
        .icons {
          & i {
            margin-left: 6px;
            font-size: 20px;
            cursor: pointer;
          }
          & :nth-child(1) {
            color: #569ef8;
          }
          & :nth-child(2) {
            color: #f56c6c;
          }
        }
      }
    }
    .image {
      width: 68px;
      height: 68px;
    }
  }
}
.btn-icon-container {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  max-height: 490px;
  overflow: auto;
  .btn-icon-item {
    width: 40px;
    height: 40px;
    flex-grow: 0;
    flex-shrink: 0;
    background: #f2f2f2;
    line-height: 40px;
    text-align: center;
    border-radius: 2px;
    cursor: pointer;
    &:hover,
    &.selected {
      background: #409fff;
      color: #fff;
    }
    i {
      font-size: 18px;
    }
  }
}
</style>
